import React, {useCallback, useState} from 'react';
import DashboardMain_Bus from '../DashboardMain_Bus/DashboardMain_Bus';
import SecondPageFilterSection from './FaultSecondPage/SecondPageFilterSection';
import SecondPageDataSection from './FaultSecondPage/SecondPageDataSection';
import SecondPageFirstGraph from './FaultSecondPage/SecondPageFirstGraph';
import SecondPageSecondGraph from './FaultSecondPage/SecondPageSecondGraph';

export default function FaultSingleVinAnalysis(props){

    const [secondPageState, setSecondPageState] = useState({
        startDate: props.gloablfilter.startDate,
        endDate: props.gloablfilter.endDate,
        vin_num: props.gloablfilter.VIN_NUM.toString(),
        CITY: props.gloablfilter.CITY,
        DEPO: props.gloablfilter.DEPO,
    });

    const filterSubmited = useCallback((data) => {
        setSecondPageState(data);
    }, []);

    const onreset = (data) => {
        setSecondPageState({
            startDate: props.gloablfilter.startDate,
            endDate: props.gloablfilter.endDate,
            vin_num: "",
            CITY: props.gloablfilter.CITY,
            DEPO: props.gloablfilter.DEPO,
        });
    }

    return(
        <>        
        <DashboardMain_Bus >
            <SecondPageFilterSection onsubmit={filterSubmited} secondPageState={secondPageState} onreset={onreset} />
            <div className="container-fluid busdrpg1">
                <section className="graphs sec2Charts">
                    {/* <FaultSecondPageDataBars_Bus gloablfilter={secondPageState} /> */}
                    <SecondPageDataSection gloablfilter={secondPageState} />
                    <div className="row mt-4 equal-cols">
                        <SecondPageFirstGraph gloablfilter={secondPageState}/>
                        <SecondPageSecondGraph gloablfilter={secondPageState}/>
                        {/* <SecondPageSecondGraph gloablfilter={secondPageState}/> */}
                    </div>
                </section>
            </div>
        </DashboardMain_Bus>
        </>
    )
}